import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-local-login-layout',
  templateUrl: './local-login-layout.component.html',
})
export class LocalLoginLayoutComponent implements OnInit {

  constructor(
  ) {
  }

  ngOnInit(): void {
  }

}
